var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GetFile',{attrs:{"title":_vm.$t('labels.download'),"loader":_vm.attachmentLoader},on:{"get-file":_vm.getAttachment}})
}
var staticRenderFns = []

export { render, staticRenderFns }